/**
 * GraphQL enum value constants used across the commenting package.
 * These are subsets of the full GraphQL enums - only the values we need are defined here.
 */

/** Subset of ReactionContent enum values */
export const REACTION_CONTENT = {
  THUMBS_UP: 'THUMBS_UP',
} as const

/** Subset of SubscriptionState enum values */
export const SUBSCRIPTION_STATE = {
  SUBSCRIBED: 'SUBSCRIBED',
  UNSUBSCRIBED: 'UNSUBSCRIBED',
} as const

/** Subset of ThreadSubscriptionFormAction enum values */
export const SUBSCRIPTION_FORM_ACTION = {
  UNSUBSCRIBE: 'UNSUBSCRIBE',
} as const
